// FILE: src/Comman Components/UserName.js (FULLY UPDATED)

import React from 'react';
import { useSelector } from 'react-redux';

export default function UserName({ Id }) {
  const profileDetails = useSelector(state => state.groups.profileDetails[Id]);

  if (!Id) return <span className='font-bold text-red-500'>Unknown User</span>;
  if (!profileDetails) return <span className='font-bold'>Loading...</span>;
  if (profileDetails.error) return <span className='font-bold text-yellow-600'>Profile Error</span>;

  // --- THIS IS THE FIX: It now correctly uses the 'name' field for LinkedIn, and 'username' as a fallback ---
  return <span className='font-bold'>{profileDetails.name || profileDetails.username || '...'}</span>;
  // --- END OF FIX ---
}

export const FaceName = ({ Id }) => {
  const profileDetails = useSelector(state => state.groups.profileDetails[Id]);

  if (!Id) return <span className='font-bold text-red-500'>Unknown User</span>;
  if (!profileDetails) return <span className='font-bold'>Loading...</span>;
  if (profileDetails.error) return <span className='font-bold text-yellow-600'>Profile Error</span>;

  return <span className='font-bold'>{profileDetails.name || '...'}</span>;
}